<template>
  <div>
    <b-card header-tag="header" class="m-3" no-body>
      <template #header>
        <h6 class="mb-0 text-center titulo-sagres font-weight-bold" v-b-toggle.accordion-1>
          <font-awesome-icon icon="chevron-down"
            :class="['float-left', filtrosVisiveis ? 'rotating-up' : 'rotating-down']" style="margin-top: 0.75rem" />
          Convênios e Outros Instrumentos Congêneres
          <b-button class="float-right m-1" size="sm" @click="importarXML()">
            <font-awesome-icon icon="file-upload" class="mr-2" />Importar XML
          </b-button>
          <b-button size="sm" class="float-right m-1" @click="cadastrarNovoConvenio">
            <font-awesome-icon icon="plus" class="mr-2" />
            Novo Instrumento
          </b-button>
        </h6>
      </template>
      <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel" v-model="filtrosVisiveis">
        <b-card-body>
          <b-container>
            <b-form @submit.stop.prevent="filtrarConvenios">
              <b-row>
                <b-col cols="12" sm="7" lg="4" xl="3">
                  <b-form-group id="input-group-filtroNumero" label="Número" label-for="input-filtroNumero"
                    label-class="text-left">
                    <b-form-input id="input-filtroNumero" v-model="filtros.numero" type="text"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="5" lg="4" xl="3">
                  <b-form-group id="input-group-filtroAno" label="Ano" label-for="input-filtroAno"
                    label-class="text-left">
                    <b-form-input id="input-filtroAno" v-model="filtros.ano" type="text"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col id="input-group-filtroTipo" cols="12" xl="6">
                  <span class="d-block text-left pb-1">Tipo</span>
                  <multiselect @input="updateFiltroTipo" v-model="tipoSelecionado" open-direction="bottom"
                    :close-on-select="true" :searchable="true" deselect-label="" :allow-empty="true"
                    placeholder="Selecione o tipo" track-by="Codigo" :options="tiposConvenio" label="Nome"
                    :show-labels="false">
                    <template slot="noOptions">
                      <small><i>Erro ao obter dados.</i></small>
                    </template>
                    <template slot="noResult">
                      <i>Sem resultados.</i>
                    </template>
                  </multiselect>
                </b-col>
                <b-col cols="12" md="6" xl="6">
                  <b-form-group id="input-group-filtroObjeto" label="Objeto"
                    label-for="input-filtroObjeto" label-class="text-left">
                    <b-form-input id="input-filtroObjeto" v-model="filtros.objeto" type="text">
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="12" xl="4" class="pt-4">
                  <div class="d-flex">
                    <b-button size="sm" variant="outline-secondary" class="mr-2" @click="limparFiltros">
                      <font-awesome-icon icon="redo" class="mr-2" />
                      Limpar Filtros
                    </b-button>
                    <b-button size="sm" variant="outline-secondary" type="submit">
                      <font-awesome-icon icon="filter" class="mr-2" />
                      Filtrar
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </b-form>
          </b-container>
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-card class="m-3" id="convenio-table-Card" no-body header-tag="header">
      <template #header>
        <h6 class="mb-0 text-center">Resultados</h6>
      </template>
      <b-card-text>
        <b-table :busy="tableBusy" :fields="fields" hover no-border-collapse :items="items" sort-by="" :sort-desc="true"
          striped stacked="lg" per-page="0" :current-page="currentPage" show-empty small>
          <template #empty>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #emptyfiltered>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #table-busy>
            <div class="text-center text-dark">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="loading-text">Carregando...</strong>
            </div>
          </template>
          <template v-slot:cell(actions)="row">
            <div class="actions-icons">
              <b-link class="text-dark" @click="detalhesConvenio(row.item.IdConvenio)">
                <font-awesome-icon icon="eye" />
                <div style="font-size: 12px">Ver Detalhes</div>
              </b-link>
              <b-link class="text-dark" @click="editarConvenio(row.item.IdConvenio)">
                <font-awesome-icon icon="edit" />
                <div style="font-size: 12px">Editar</div>
              </b-link>
              <b-link class="text-dark" @click="abrirModalCancelamento(row.item)">
                <font-awesome-icon icon="times" />
                <div style="font-size: 12px">Cancelar</div>
              </b-link>
              <btn-excluir :idItem="row.item.IdConvenio" :excluirItem="removerConvenio" />
            </div>
          </template>
        </b-table>
        <table-pagination v-if="totalRows" :total-rows="totalRows" :per-page="pageSize" @pageChange="pageChange">
        </table-pagination>
      </b-card-text>
    </b-card>
    <validation-observer ref="observer" v-slot="{handleSubmit}">
    <b-modal id="modal-cancelamento" size="md" button-size="sm" centered header-bg-variant="secondary" header-text-variant="light"
        header-class="" footer-class="" modal-class="p-2" no-close-on-backdrop no-close-on-esc>
        <template v-slot:modal-header="">
          <h5>{{`Cancelar Instrumento ${informacaoCancelamento.numeroConvenio}/${informacaoCancelamento.anoConvenio}`}}</h5>
        </template>
        <div>
          <b-form>
            <b-row>
              <b-col cols="12">
                <validation-provider rules="required" v-slot="validationContext" name="dataCancelamento">
                  <b-form-group class="formGroup" id="dataCancelamento-input-group"
                    label="Data do Cancelamento *" label-for="input-dataCancelamento" label-cols="auto"
                    content-cols="12">
                    <b-form-datepicker id="input-dataCancelamento" :disabled="informacaoCancelamentoCarregada"
                      :state="getValidationState(validationContext)" v-model="informacaoCancelamento.dataCancelamento"
                      placeholder="Selecione uma data" value-as-date label-no-date-selected="Nenhuma data selecionada"
                      label-help="Use as setas para navegar pelas datas" label-prev-year="Ano anterior"
                      label-prev-month="Mês anterior" label-current-month="Mês atual" label-next-month="Próximo mês"
                      label-next-year="Próximo ano"></b-form-datepicker>
                    <b-form-invalid-feedback id="input-dataCancelamento-live-feedback">{{
                        validationContext.errors[0]
                    }}</b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>  
              </b-col>
              <b-col cols="12">
                <validation-provider rules="required" v-slot="validationContext" name="motivoCancelamento">
                  <b-form-group id="motivoCancelamento-input-group" label="Motivo do Cancelamento *"
                    label-for="input-motivoCancelamento" label-cols="auto" content-cols="12">
                    <b-form-textarea :disabled="informacaoCancelamentoCarregada" id="input-motivoCancelamento" :state="getValidationState(validationContext)"
                      v-model="informacaoCancelamento.motivoCancelamento" rows="3" max-rows="6"></b-form-textarea>
                    <b-form-invalid-feedback id="input-motivoCancelamento-live-feedback">{{ validationContext.errors[0]
                    }}</b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12">
                <b-form-group class="formGroup mb-5" id="arquivo-cancelamento-input-group"
                  label="Arquivo Texto do Cancelamento do Instrumento (PDF) *" label-for="input-arquivo-cancelamento" label-cols="auto"
                  content-cols="12">
                  <validation-provider v-if="!informacaoCancelamentoCarregada || (informacaoCancelamentoCarregada && (informacaoCancelamento.arquivoCancelamento === null || informacaoCancelamento.arquivoCancelamento === undefined))" rules="required" v-slot="validationContext" name="arquivoCancelamento">
                    <b-form-file v-model="informacaoCancelamento.arquivoCancelamentoForm" :state="getValidationState(validationContext)"
                      placeholder="Selecione..." drop-placeholder="Solte o arquivo aqui..." class=""
                      browse-text="Escolher" accept=".pdf"></b-form-file>
                    <b-form-invalid-feedback id="input-arquivo-cancelamento-live-feedback">{{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                  <div v-else class="">
                    <btn-download class="mr-2" :fazerDownload="baixarAnexo" :parametros="informacaoCancelamento.arquivoCancelamento" />
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
          
        </div>
        <template v-slot:modal-footer="">
          <b-button v-if="!informacaoCancelamentoCarregada"  @click="handleSubmit(cancelarConvenio)">
            <font-awesome-icon icon="save" class="mr-2" />Salvar
          </b-button>
          <b-button v-else  @click="handleSubmit(desfazerCancelamentoConvenio)">
            <font-awesome-icon icon="undo" class="mr-2" />Desfazer Cancelamento
          </b-button>
          <b-button variant="outline-secondary" @click="$bvModal.hide('modal-cancelamento')">
            Fechar
          </b-button>
        </template>
      </b-modal>
      </validation-observer>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component';

import { UtilsTS } from '@/utilsts';
import BtnExcluir from '@/components/shared/btn-excluir.vue'
import BtnDownload from '@/components/shared/btn-download.vue'
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";
import Multiselect from "vue-multiselect";
import { TableField } from '@/types/table-field'
import { store } from "@/store"

import conveniosService from '@/services/licitacoes/conveniosService'
import { fieldsConvenios } from '@/types/licitacoes/convenio/fields-convenios'
import { InformacaoCancelamento } from '@/types/licitacoes/convenio/informacao-cancelamento'
import { ConvenioResumido } from '@/types/licitacoes/convenio/convenio-resumido'
import { FiltrosConvenios } from '@/types/licitacoes/convenio/filtros-convenios';
import { Convenio } from '@/types/licitacoes/convenio';
import { ArquivoConvenio } from '@/types/licitacoes/arquivo-convenio';
import { ValidationProvider, ValidationObserver} from "vee-validate";

const CompProps = Vue.extend({
  name: 'ConsultarConvenios',
  components: { BtnDownload, BtnExcluir, Multiselect, TablePagination, ValidationProvider, ValidationObserver },
})

@Component
export default class ConsultarConvenios extends mixins(UtilsTS, CompProps) {
  currentPage = 1
  fields: TableField[] = fieldsConvenios
  items: ConvenioResumido[] = []
  tableBusy = false
  filtrosVisiveis = true
  tipoSelecionado: any = null
  filtros: FiltrosConvenios = new FiltrosConvenios()
  tiposConvenio: any[] = []
  informacaoCancelamento: InformacaoCancelamento = new InformacaoCancelamento()
  informacaoCancelamentoCarregada = false

  pageSize = 10
  totalRows: null | number = null

  async pageChange(value) {
    this.tableBusy = true;
    this.currentPage = value;
    await this.loadData();
  }

  async loadData(): Promise<void> {
    this.tableBusy = true
    try {
      const response = await conveniosService.filtrarConvenios(
        this.currentPage,
        this.pageSize,
        this.filtros
      );
      this.totalRows = response.totalRows;
      this.items = response.conveniosResumidos.map(p => {
        const retorno = Object.assign(new ConvenioResumido(), p)
        retorno.tratarDadosDaAPI()
        return retorno
      })
    } catch (e: any) {
      this.items = []
      this.tratarError(e)
    } finally {
      this.tableBusy = false;
    }
  }

  async mounted() {
    try {
      store.blockScreen = true
      const responseTiposConvenio = await conveniosService.listarTiposConvenio()
      this.tiposConvenio = [{ Nome: 'TODOS', Codigo: null }, ...responseTiposConvenio.data.map(t => {
        return { Codigo: t.IdTipoConvenio, Nome: t.DeTipoConvenio }
      }
      )]
      await this.loadData()
    } finally {
      store.blockScreen = false
    }
  }

  getValidationState({ dirty, validated, valid = null }): any {
    return dirty || validated ? valid : null;
  }

  filtrarConvenios() {
    this.pageChange(1);
  }

  limparFiltros() {
    this.tipoSelecionado = null;
    this.filtros.limpar();
    this.pageChange(1);
  }

  updateFiltroTipo() {
    this.filtros.idTipo = this.tipoSelecionado.Codigo;
  }

  importarXML(): void {
    this.$router.push('/modulo-licitacoes/convenios/importar-xml')
  }

  cadastrarNovoConvenio(): void {
    this.$router.push('/modulo-licitacoes/convenios/novo')
  }

  editarConvenio(idConvenio: string): void {
    this.$router.push('/modulo-licitacoes/convenios/editar/' + idConvenio)
  }

  detalhesConvenio(idConvenio: string): void {
    this.$router.push('/modulo-licitacoes/convenios/' + idConvenio)
  }

  async removerConvenio(id: number): Promise<void> {
    try {
      store.blockScreen = true
      const resp = await conveniosService.removerConvenio(id)
      if (resp && resp.status === 204) {
        await this.loadData()
        this.$toast.success("Instrumento excluído com sucesso")
      } else {
        console.error('Erro ao remover instrumento', resp)
        this.$toast.error(resp.data.msg || 'Erro ao remover instrumento')
      }
    } catch (e: any) {
      console.error('Erro ao remover instrumento', e)
      this.$toast.error(e.message || 'Erro ao remover instrumento')
    } finally {
      store.blockScreen = false
    }
  }

  async cancelarConvenio(): Promise<void> {
    try {
      store.blockScreen = true
      const resp = await conveniosService.cancelarConvenio(this.informacaoCancelamento)
      if (resp && resp.status === 200) {
        this.$bvModal.hide('modal-cancelamento')
        await this.loadData()
        this.$toast.success("Instrumento cancelado com sucesso")
      } 
      else if (resp && resp.status === 400 && resp.data.erros) {
      resp.data.erros.forEach(erro => {
        this.$toast.error(erro, {
          timeout: false
        });
      });
      } else {
        console.error('Erro ao cancelar instrumento', resp)
        this.$toast.error(resp.data.msg || 'Erro ao cancelar instrumento')
      }
    } catch (e: any) {
      console.error('Erro ao cancelar instrumento', e)
      this.$toast.error(e.message || 'Erro ao cancelar instrumento')
    } finally {
      store.blockScreen = false
    }
  }

  async desfazerCancelamentoConvenio(): Promise<void> {
    try {
      store.blockScreen = true
      const resp = await conveniosService.desfazerCancelamento(this.informacaoCancelamento.idConvenio)
      if (resp && resp.status === 200) {
        await this.loadData()
        this.$toast.success("Alteração realizada com sucesso")
      } else {
        console.error('Erro ao desfazer cancelamento do instrumento', resp)
        this.$toast.error(resp.data.msg || 'Erro ao desfazer cancelamento do instrumento')
      }
    } catch (e: any) {
      console.error('Erro ao desfazer cancelamento do instrumento', e)
      this.$toast.error(e.message || 'Erro ao desfazer cancelamento do instrumento')
    } finally {
      this.$bvModal.hide('modal-cancelamento')
      store.blockScreen = false
    }
  }

  async abrirModalCancelamento(item) {
    try {
      store.blockScreen = true
      this.informacaoCancelamentoCarregada = false
      this.informacaoCancelamento.idConvenio = item.IdConvenio
      const resp = await conveniosService.buscarConvenio(item.IdConvenio)
      const infoConvenio: Convenio = resp.data
      if (resp && resp.status === 200) {
        this.informacaoCancelamento.numeroConvenio = infoConvenio.NrConvenio
        this.informacaoCancelamento.anoConvenio = infoConvenio.NrAnoConvenio
        this.informacaoCancelamento.motivoCancelamento = infoConvenio.DeMotivoCancelConv
        this.informacaoCancelamento.dataCancelamento = infoConvenio.DtCancelamentoConv
        this.informacaoCancelamento.arquivoCancelamento = infoConvenio.ArquivoConvenio.find(x => x.IsArquivoEdital === false)

        if(this.informacaoCancelamento.dataCancelamento !== null)
          this.informacaoCancelamentoCarregada = true;
        
        this.$bvModal.show('modal-cancelamento');
      } else {
        console.error('Erro ao buscar informações do instrumento', resp)
        this.$toast.error(resp.data.msg || 'Erro ao buscar informações do instrumento')
      }
    } catch (e: any) {
      console.error('Erro ao buscar informações do instrumento', e)
      this.$toast.error(e.message || 'Erro ao buscar informações do instrumento')
    } finally {
      store.blockScreen = false
    }
  }

  isInformacaoCancelamentoPreenchido() {
    return    this.informacaoCancelamento.idConvenio !== null
           && this.informacaoCancelamento.numeroConvenio !== null
           && this.informacaoCancelamento.anoConvenio !== null
           && this.informacaoCancelamento.dataCancelamento !== null
           && this.informacaoCancelamento.motivoCancelamento !== null
           && this.informacaoCancelamento.arquivoCancelamentoForm !== null

  }

  async baixarAnexo(arquivo: ArquivoConvenio) {
    const response = await conveniosService.baixarAnexo(arquivo.IdArquivo)
    this.download(arquivo.DeNomeArquivo, response.data)
  }
};
</script>

<style scoped>
:deep(#input-group-filtroTipo .multiselect) {
  width: 100%;
  max-width: 100%;
}

:deep(#input-group-filtroTipo .multiselect__tags) {
  border: #ced4da solid 1px !important;
  border-radius: 3px !important;
}

:deep(#input-group-filtroTipo .multiselect__option) {
  padding: 6px !important;
  min-height: 0;
  font-size: 16px;
}

:deep(#input-group-filtroTipo .multiselect__option--selected) {
  color: #495057 !important;
  background: #fff;
  font-weight: 400;
}

:deep(#input-group-filtroTipo .multiselect__content-wrapper) {
  border: 1px solid #ced4da;
  max-height: 200px !important;
}

:deep(#input-group-filtroTipo .multiselect__option--highlight) {
  background: #007bff !important;
  color: #fff !important;
}

:deep(#input-group-filtroTipo .multiselect__input,
.multiselect__single) {
  background-color: #fff !important;
  color: #495057 !important;
}

:deep(#input-group-filtroTipo .multiselect__input::placeholder) {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #495057 !important;
}

:deep(#input-group-filtroTipo .multiselect__input::active) {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  border: none;
}

:deep(#input-group-filtroTipo .multiselect__tags) {
  background-color: #fff;
  color: #495057 !important;
  border-radius: 2px;
}

:deep(#input-group-filtroTipo .multiselect__select:before) {
  color: #495057 !important;
  border-color: #495057 transparent transparent !important;
}

:deep(#input-group-filtroTipo .multiselect) {
  z-index: 2;
}

:deep(#input-group-filtroTipo .multiselect__placeholder) {
  color: #495057;
  font-weight: 400;
  font-size: 1rem;
}

:deep(#input-group-filtroTipo .multiselect__single) {
  cursor: pointer;
}

:deep(#input-group-filtroTipo .multiselect__input,
#input-group-filtroTipo .multiselect__single) {
  vertical-align: initial;
}

:deep(#input-group-filtroTipo .multiselect--disabled .multiselect__tags,
#input-group-filtroTipo .multiselect--disabled .multiselect__tags span) {
  color: #6c757d !important;
}

:deep(#input-group-filtroTipo .multiselect--disabled .multiselect__select) {
  background: #fff !important;
}

:deep(table.b-table div) {
  word-break: inherit
}

</style>